import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Gauge } from 'lucide-react';
import { COLORS } from '../../utils/constants';

const C = COLORS;

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) { setError('Please fill in all fields.'); return; }
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      // The PublicRoute component will automatically redirect to /dashboard 
      // once the AuthContext state updates isAuthenticated to true.
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const inp = { width: '100%', padding: '12px 14px', border: `1px solid ${C.g200}`, borderRadius: 10, fontSize: 14, outline: 'none', background: C.g50, boxSizing: 'border-box' };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: `linear-gradient(135deg, ${C.primaryGhost} 0%, #fff 50%, #F0FDFA 100%)`, padding: 20 }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 56, height: 56, borderRadius: 16, background: `linear-gradient(135deg, ${C.primary}, ${C.primaryLight})`, marginBottom: 16, boxShadow: '0 8px 24px rgba(79,70,229,0.3)' }}>
            <Gauge size={28} color="#fff" />
          </div>
          <h1 style={{ margin: 0, fontSize: 28, fontWeight: 800, color: C.g900 }}>Worldeye</h1>
          <p style={{ margin: '6px 0 0', color: C.g500, fontSize: 15 }}>Management System</p>
        </div>

        <div style={{ background: '#fff', borderRadius: 16, border: `1px solid ${C.g200}`, padding: 32, boxShadow: '0 20px 60px rgba(0,0,0,0.06)' }}>
          <h2 style={{ margin: '0 0 4px', fontSize: 22, fontWeight: 700, color: C.g900 }}>Welcome back</h2>
          <p style={{ margin: '0 0 28px', color: C.g500, fontSize: 14 }}>Sign in to your account</p>

          {error && (
            <div style={{ padding: '10px 14px', background: C.dangerLight, borderRadius: 10, marginBottom: 20, fontSize: 13, color: C.danger }}>{error}</div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', marginBottom: 6, fontSize: 13, fontWeight: 600, color: C.g700 }}>Email Address</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" style={inp} />
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', marginBottom: 6, fontSize: 13, fontWeight: 600, color: C.g700 }}>Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" style={inp} />
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: C.g600, cursor: 'pointer' }}>
                <input type="checkbox" style={{ accentColor: C.primary }} /> Remember me
              </label>
            </div>
            <button type="submit" disabled={loading}
              style={{ width: '100%', padding: '12px 20px', background: loading ? C.g300 : C.primary, color: '#fff', border: 'none', borderRadius: 12, fontSize: 15, fontWeight: 600, cursor: loading ? 'default' : 'pointer', fontFamily: 'inherit' }}>
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
